import { render, staticRenderFns } from "./WorkEnv.vue?vue&type=template&id=56f3aacb"
import script from "./WorkEnv.vue?vue&type=script&lang=js"
export * from "./WorkEnv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports